// removed by extract-text-webpack-plugin
module.exports = {"tile":"tile__Mg9mu","tileDescription":"tileDescription__1LHKI","tileDescriptionHeader":"tileDescriptionHeader__TeV23","tileDescriptionContent":"tileDescriptionContent__pQMj0","tileImageContainer":"tileImageContainer__2YNm-","slick-slide":"slick-slide__rXcbj","imageTile":"imageTile__1OFFm","merchantCardWrapper":"merchantCardWrapper__38Bes"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/merchants/style.css
// module id = qYEq
// module chunks = 323